import apiClient from './client';

export interface HubUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
}

export interface UserFilters {
  page?: number;
  limit?: number;
  search?: string;
  role?: string;
  isActive?: boolean;
  sortBy?: string;
  order?: 'ASC' | 'DESC';
}

export class UsersService {
  async getAllUsers(filters: UserFilters = {}): Promise<{ success: boolean; data: HubUser[]; pagination?: any }> {
    const response = await apiClient.get('/users', { params: filters });
    return response.data;
  }
  async getUsersByRole(roleName: string): Promise<{ success: boolean; data: HubUser[]}> {
    const response = await apiClient.get(`/users/by-role/${roleName}`);
    return response.data;
  }
}

export const usersService = new UsersService();
